import async from 'async'
import _ from 'lodash'

const x = {
    checkRights: (dataRight) => {

        let rightsList = localStorage.getItem('rights') !== 'undefined' ? JSON.parse(localStorage.getItem('rights')) : null;
        if (dataRight !== undefined) {
            let rightObj = dataRight.split('.')
            if (rightsList && rightsList[rightObj[0]] && rightsList[rightObj[0]][rightObj[1]]) {
                return true
            } else {
                return false
            }
        } else {
            return true
        }

    },
    checkMultipleRights: (dataRights) => {
        let checkRights = false;
        let rightsList = localStorage.getItem('rights') !== 'undefined' ? JSON.parse(localStorage.getItem('rights')) : null;
        if (dataRights !== undefined) {
            _.each(dataRights, (dataRight, index) => {
                let rightObj = dataRight.split('.');
                if (rightsList && rightsList[rightObj[0]] && rightsList[rightObj[0]][rightObj[1]] != undefined) {
                    checkRights = true
                }
            })
        } else {
            checkRights = true
        }
        return checkRights;
    },

    checkSideMenuRights: (data, callback) => {

        let returnValue = false
        let rightsList = localStorage.getItem('rights') !== 'undefined' ? JSON.parse(localStorage.getItem('rights')) : null
        let findRight = _.find(data.children, (item) => {
            return item.rights
        })
        if (findRight) {
            async.each(data.children, (item, cb) => {
                let dataRight = item.rights
                if (dataRight !== undefined) {
                    let rightObj = dataRight.split('.')
                    if (rightsList && rightsList[rightObj[0]] && rightsList[rightObj[0]][rightObj[1]]) {
                        if (returnValue == false) {
                            returnValue = true
                        }
                        cb()
                    } else {
                        cb()
                    }
                } else {
                    cb()
                }
            }, () => {
                return callback(returnValue)
            })
        } else {
            return callback(true)
        }
    },

    checkUserRights: (dataRight) => {
        let rightsList = localStorage.getItem('rights') !== 'undefined' ? JSON.parse(localStorage.getItem('rights')) : null
        if (dataRight !== undefined) {
            let rightObj = dataRight
            if (rightsList && rightsList[rightObj]) {
                return true
            } else {
                return false
            }
        } else {
            return true

        }
    },

    getUserAuth: (fieldKey = null) => {
        const loginUser = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : null;

        if (!loginUser) {
            return '';
        }
        if (fieldKey != null) {
            return loginUser[fieldKey];
        }
        return loginUser;
    }
}

export default x
